import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import {FormGroup} from '@angular/forms';
import{LoopBackAuth, listadosService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import { isNull } from 'util';

@Component({
  selector: 'datos-ubicacion',
  template: `
  <form name="form-inscripciones" [formGroup]="ubicacion">
    <div class="row">
      <label class="col-sm-4 col-form-label text-right">
       Provincia: <span class="text-danger">*</span> </label>
      <div class="col-sm-8">
          <div
          class="input-group input-group-sm"
          [ngClass]="{'showError': !ubicacion.get('provincia').valid && (ubicacion.get('provincia').touched && ubicacion.get('provincia').value == null) }">
              <select
              name="provincia"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="provincia"
              (change)="onChangeCantones($event.target.value)">
              <option value="null">SELECCIONE UNA PROVINCIA</option>
              <option *ngFor="let item of provincias" [value]="item.id">{{item.descripcion | uppercase}}</option>
          </select>
          </div>
      </div>
      <label class="col-sm-4 col-form-label text-right">
      Canton: <span class="text-danger">*</span> </label>
      <div class="col-sm-8">
          <div
          class="input-group input-group-sm"
          [ngClass]="{'showError': (!ubicacion.get('canton').valid && ubicacion.get('canton').touched) && ubicacion.get('canton').value == null}">
              <select
              name="alumnoTipo"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="canton"
              (change)="onChangeParroquias($event.target.value)">
              <option value="null">SELECCIONE UN CANTON</option>
              <option *ngFor="let item of cantones" [value]="item.id">{{item.descripcion | uppercase}}</option>
          </select>
          </div>
      </div>
      <label class="col-sm-4 col-form-label text-right">
          Parroquia: <span class="text-danger">*</span> </label>
      <div class="col-sm-8">
          <div
          class="input-group input-group-sm"
          [ngClass]="{'showError': (!ubicacion.get('parroquia').valid && ubicacion.get('parroquia').touched) && ubicacion.get('parroquia').value == null}">
              <select
              name="alumnoTipo"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="parroquia"
              >
              <option value="null">SELECCIONE UNA PARROQUIA</option>
              <option *ngFor="let item of parroquias" [value]="item.id">{{item.descripcion | uppercase}}</option>
          </select>
          </div>
      </div>
    </div>
  </form>
  `,
  providers:[LoopBackAuth, listadosService, MessageService]
})
export class DatosUbicacionComponent implements OnInit, OnChanges {
  @Input() ubicacion:FormGroup
  @Input() nacionalidad: String
  @Input() spinner: any
  public provincias: any = []
  public cantones: any[]
  public parroquias: any[]
  
  constructor(
    private listadosService:listadosService
  ) { }

  ngOnInit() {
    this.spinner.isSpinnerVisible = true
    this.listadosService.provincias().subscribe(
      result =>{
        this.provincias = result
        if(this.ubicacion.get('provincia').value != null && this.ubicacion.get('provincia').value != ""){
          this.onChangeCantones(this.ubicacion.get('provincia').value)
          if(this.ubicacion.get('canton').value != null && this.ubicacion.get('canton').value != ""){
            this.onChangeParroquias(this.ubicacion.get('canton').value)
          }
        }
        this.spinner.isSpinnerVisible = false
      }   
    )
  }

  ngOnChanges(changes:SimpleChanges) {
    if(changes.nacionalidad != undefined && changes.nacionalidad.currentValue != undefined && this.provincias.length > 0){
      if(changes.nacionalidad.currentValue != 5){
        this.ubicacion.get('provincia').setValue('25')
          this.onChangeCantones('25')
          this.ubicacion.get('canton').setValue(this.cantones[0].id)
          this.onChangeParroquias(this.cantones[0].id)
          this.ubicacion.get('parroquia').setValue(this.parroquias[0].id)
          this.ubicacion.disable()
      }
      else{
        this.ubicacion.enable()
        if(!(changes.nacionalidad.previousValue == undefined)){
          this.ubicacion.get('provincia').setValue(null)
          this.ubicacion.get('canton').setValue(null)
          this.ubicacion.get('parroquia').setValue(null)
        }
      }
    }
  }

  
  onChangeCantones(provincia:string){
    if(provincia != 'null'){
      this.cantones = this.provincias[this.provincias.findIndex((x)=>x.id==provincia)].cantones
    }else{
      this.ubicacion.get('canton').setValue(null)
      this.cantones = []
    }
  }

  onChangeParroquias(canton:string){
    if(canton != 'null'){
      this.parroquias = this.cantones[this.cantones.findIndex((x)=>x.id==canton)].parroquias
    }else{
      this.ubicacion.get('parroquia').setValue(null)
      this.parroquias = []
    }
      
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-ubicacion.component.ts